import React from 'react';

import { IconCheck, IconClose, IconExclamation, IconInfo } from '../Icon';
import {
  CloseButton,
  FloatingAlertWrapper,
  FloatingInner,
  Heading,
  Icon,
  IconBadge,
  Main,
  UiBlock,
  Wrapper,
} from './wrapper';

export interface IAlert {
  children: React.ReactNode;
  heading?: string;
  tone?: 'success' | 'warning' | 'error' | 'info';
}

const getIcon = (tone: string) => {
  switch (tone) {
    case 'success':
      return <IconCheck />;
    case 'warning':
    case 'error':
      return <IconExclamation />;
    default:
      return <IconInfo />;
  }
};

const Alert = ({ children, heading, tone }: IAlert) => (
  <Wrapper $tone={tone}>
    <Icon>
      <IconBadge>{getIcon(tone || '')}</IconBadge>
    </Icon>
    <Main>
      {heading && <Heading>{heading}</Heading>}
      {children}
    </Main>
  </Wrapper>
);

export default Alert;

interface IFloatingAlert extends IAlert {
  onClose: () => void;
}

export const FloatingAlert = ({ children, heading, tone, onClose }: IFloatingAlert) => (
  <FloatingAlertWrapper>
    <UiBlock onClick={onClose} />
    <FloatingInner>
      <Alert {...{ children, heading, tone }} />
      <CloseButton onClick={onClose}>
        <IconClose />
      </CloseButton>
    </FloatingInner>
  </FloatingAlertWrapper>
);
